import enUS from './en-US';
import de from './de';
import fr from './fr-FR';
import da from './da';
import nlNL from './nl-NL';
import noNO from './no-NO';
import svSE from './sv-SE';
import roRO from './ro-RO';
import bgBG from './bg-BG';
import hrHR from './hr-HR';
import ltLT from './lt-LT';
import etEE from './et-EE';

export default {
  da,
  de,
  'en-US': enUS,
  'fr-FR': fr,
  'nl-NL': nlNL,
  'no-NO': noNO,
  'sv-SE': svSE,
  'ro-RO': roRO,
  'bg-BG': bgBG,
  'hr-HR': hrHR,
  'lt-LT': ltLT,
  'et-EE': etEE,
};
